/**
 * Market Watch UI feature flags.
 *
 * Each flag gates ONLY visibility/labeling behavior — no underlying logic
 * or code paths are removed. Flip a flag to false to fully restore the
 * pre-flag behavior.
 */

/**
 * When true, the JESS-rendered "MW Recommendations" sheet is hidden and the
 * "MW Rec Details" sheet is renamed to "MW Recommendations" so the user sees
 * a single consolidated Recommendations tab.
 *
 * When false, both tabs are visible with their original names — the legacy
 * two-tab behavior. All sheet-creation logic in marketWatchPipeline.ts,
 * createAnalysisSheet, renderExcelStyledReport, and createFlattenedGridSheet
 * is unchanged regardless of this flag's value.
 */
export const MW_SINGLE_RECOMMENDATIONS_VIEW = true;
